module.exports = __webpack_public_path__ + "img/Food_Science-RN-t-21841-008.f0c67ef8.jpg";